import { useQuery, gql } from '@apollo/client';

const FETCH_TERMS = gql`
  query Fetch_GeneralTerms {
    generalContractVersions(contractType: [privacy, terms, vnm]) {
      id
      displayName
      fileUrl
      contractType
      contractId
      internalName
      signatureType
      contractVersionLanguage {
        id
        fileUrl
      }
    }
  }
`;

export const useGeneralTerms = () => {
  const { loading, error, data } = useQuery(FETCH_TERMS);

  return {
    loading,
    error,
    data,
  };
};

export const useGeneralTermsMock = {
  loading: false,
  error: undefined,
  data: {
    generalContractVersions: [
      {
        id: 1,
        displayName: 'Privacy Policy',
        fileUrl: 'https://www.example.com/privacy-policy',
        contractType: 'privacy',
        contractId: 1,
        internalName: 'privacy_policy',
        signatureType: 'agreement',
        contractVersionLanguage: {
          id: 1,
          fileUrl: 'https://www.example.com/privacy-policy/en',
        },
      },
      {
        id: 2,
        displayName: 'Terms of Service',
        fileUrl: 'https://www.example.com/terms-of-service',
        contractType: 'terms',
        contractId: 2,
        internalName: 'terms_of_service',
        signatureType: 'agreement',
        contractVersionLanguage: {
          id: 2,
          fileUrl: 'https://www.example.com/terms-of-service/en',
        },
      },
      {
        id: 3,
        displayName: 'VNM Agreement',
        fileUrl: 'https://www.example.com/vnm-agreement',
        contractType: 'vnm',
        contractId: 3,
        internalName: 'vnm_agreement',
        signatureType: 'agreement',
        contractVersionLanguage: {
          id: 3,
          fileUrl: 'https://www.example.com/vnm-agreement/en',
        },
      },
    ],
  },
};
